module.exports = __webpack_public_path__ + "img/buttonArrowBack.708e27db.svg";